/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";

function AddSubForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();

  const [formData, setFormData] = useState({
    heading: "",
    delivery_charges: "",
    is_delivery_charge: 0,
    is_meal_type: 0,
    item_qty: "",
    cat_discount: "",
    categories: [],
    details: "",
    amount: "",
    is_company_sub: 0,
    outlet_id: user?.user?.outlet_id,
    user_id: user?.user?.id,
  });

  const [categories, setCategories] = useState([]);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelect = (item) => {
    // Check if the category is already selected
    const alreadySelected = formData.categories.some(
      (category) => category.category_id === item.value
    );

    if (alreadySelected) return; // Prevent duplicates

    setFormData((prev) => ({
      ...prev,
      categories: [
        ...prev.categories,
        {
          category_id: item.value,
          name: item.label,
          quantity: 1,
        },
      ],
    }));
  };

  const handleDelete = (id) => {
    setFormData((prev) => ({
      ...prev,
      categories: prev.categories.filter((item) => item.category_id !== id),
    }));
  };

  const handleQtyChange = (e, id) => {
    setFormData((prev) => ({
      ...prev,
      categories: prev.categories.map((item) =>
        item.category_id === id ? { ...item, quantity: e.target.value } : item
      ),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    formData.full_amount = formData.amount;

    if (!id) {
      axios
        .post(`${apiKey}/api/rms/admin/subscription`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          Object.keys(err.response.data.data).forEach((item) => {
            err.response.data.data[item].forEach((i) => {
              toast.error(i || "Validation Error");
            });
          });
        });
    } else {
      axios
        .put(`${apiKey}/api/rms/admin/subscription/${id}`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          Object.keys(err.response.data.data).forEach((item) => {
            err.response.data.data[item].forEach((i) => {
              toast.error(i || "Validation Error");
            });
          });
        });
    }
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/categories`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          subscriptions_status: "active",
          outlet_id: user?.user?.outlet_id,
        },
      })
      .then((res) => {
        const mappedCategories = res.data.map((item) => ({
          value: item.id,
          label: item.category_name,
        }));
        setCategories(mappedCategories);
      });

    axios
      .get(`${apiKey}/api/rms/customer/serviceDeliveryCharge`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setFormData((prev) => ({
          ...prev,
          delivery_charges:
            res.data.data.service_delivery_charges.delivery_charges || 0,
        }));
      })
      .catch((err) => {
        console.error("Error fetching service delivery charge:", err);
      });

    if (id) {
      axios
        .get(`${apiKey}/api/rms/admin/subscription/${id}`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          setFormData((prev) => ({
            ...prev,
            ...res.data.data,
            categories: res.data.data.subscription_categories?.map((item) => ({
              category_id: item.category_id,
              name: item.categories.category_name,
              quantity: item.quantity,
            })),
          }));
        })
        .catch((err) => {
          console.error("Error fetching subscription data:", err);
        });
    }
  }, [id, setCategories, user?.token, user?.user?.outlet_id]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      item_qty: formData.categories.reduce(
        (acc, item) => acc + Number(item.quantity),
        0
      ),
    }));
  }, [formData.categories]);

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">Add Subscriptions</h1>
          </div>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="w-full lg:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Package Name
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder=""
                    name="heading"
                    onChange={handleChange}
                    value={formData.heading}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full lg:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Package Amount
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder=""
                    name="amount"
                    onChange={handleChange}
                    value={formData.amount}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full lg:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Expire Days
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Expire Days"
                    name="expire_days"
                    onChange={handleChange}
                    value={formData.expire_days}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>
            {/* **************************************RADIO BUTTON SELRCT */}
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Category
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder="Select"
                    options={categories}
                    defaultValue={{
                      label: formData.categories.id,
                      value: formData.categories.category_name,
                    }}
                    onChange={handleSelect}
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Discount(%)
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="0"
                    name="cat_discount"
                    onChange={handleChange}
                    value={formData.cat_discount}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Service/Delivery Charge
                </span>
                <div className="flex gap-4">
                  <div className="mb-2 pt-0">
                    <input
                      type="radio"
                      name="is_delivery_charge"
                      onChange={handleChange}
                      id="ChargeY"
                      value={1}
                      checked={Number(formData.is_delivery_charge) === 1}
                    />
                    <label
                      className="form-check-label ps-2 pe-3 text-d-bg-text text-sm mb-2 "
                      for="ChargeY"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="mb-2 pt-0">
                    <input
                      type="radio"
                      name="is_delivery_charge"
                      onChange={handleChange}
                      id="ChargeN"
                      value={0}
                      checked={Number(formData.is_delivery_charge) === 0}
                    />
                    <label
                      className="form-check-label ps-2 pe-3 text-d-bg-text text-sm mb-2 "
                      for="ChargeN"
                    >
                      No
                    </label>
                  </div>
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Delivery Amount
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="100"
                    name="delivery_charges"
                    onChange={handleChange}
                    value={formData.delivery_charges}
                    disabled
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full bg-gray-100"
                  />
                </div>
              </label>
            </div>

            {/* **********************************************TABLE */}

            <table className="w-full table-fixed border-collapse pt-3 pb-3">
              <thead>
                <tr>
                  <th className="w-1/4 text-left text-sm text-d-bg-text font-semibold pb-2">
                    Category
                  </th>
                  <th className="w-1/4 text-left text-sm text-d-bg-text font-semibold pb-2">
                    Meal Qty
                  </th>
                  <th className="text-center text-sm text-d-bg-text font-semibold pb-2">
                    Delete
                  </th>
                </tr>
              </thead>
              <tbody>
                {formData?.categories?.map((item, idx) => (
                  <tr key={idx}>
                    <td>
                      <p className="px-2 py-2 text-sm">{item.name}</p>
                    </td>
                    <td>
                      <input
                        type="text"
                        value={item.quantity}
                        className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-xs shadow outline-none focus:outline-none focus:shadow-outline w-full"
                        onChange={(e) => handleQtyChange(e, item.category_id)}
                      />
                    </td>
                    <td className="text-center text-sm text-d-bg-text font-semibold pb-2">
                      <button
                        className="text-red-500 border-2 border-red-500 rounded-full p-1 cursor-pointer"
                        onClick={() => handleDelete(item.category_id)}
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* **********************************************END-TABLE */}

            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full lg:w-3/6">
                <span className=" text-d-bg-text text-sm mb-2 relative">
                  {languageHelper("Details")}
                </span>
                <div className="mb-2 pt-0">
                  <textarea
                    rows={3}
                    type="text"
                    placeholder="Details"
                    name="details"
                    onChange={handleChange}
                    value={formData.details}
                    className="px-2 py-5 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Company Subscriptions
                </span>
                <div className="mb-2 pt-0 flex gap-4">
                  <div>
                    <input
                      type="radio"
                      name="is_company_sub"
                      onChange={handleChange}
                      id="company_sub_yes"
                      value={1}
                      checked={formData.is_company_sub == 1}
                    />
                    <label
                      className="form-check-label ps-2 pe-3 text-d-bg-text text-sm mb-2 "
                      for="company_sub_yes"
                    >
                      Yes
                    </label>
                  </div>
                  <div>
                    <input
                      className="ps-5"
                      type="radio"
                      name="is_company_sub"
                      onChange={handleChange}
                      id="company_sub_no"
                      value={0}
                      checked={formData.is_company_sub == 0}
                    />
                    <label
                      className="form-check-label  ps-2 pe-3 text-d-bg-text text-sm mb-2 "
                      for="company_sub_no"
                    >
                      No
                    </label>
                  </div>
                </div>
                <div className="w-full">
                  <span className="text-d-bg-text text-xs mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                    Package Amount Discount
                  </span>
                  <div className="mb-2 pt-0">
                    <input
                      type="text"
                      placeholder=""
                      name="amount"
                      onChange={handleChange}
                      value={formData.cat_discount}
                      className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    />
                  </div>
                </div>
              </label>
              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Meal Type
                </span>
                <div className="flex gap-4">
                  <div>
                    <input
                      type="radio"
                      name="is_meal_type"
                      onChange={handleChange}
                      id="MealY"
                      value={1}
                      checked={formData.is_meal_type == 1}
                    />
                    <label
                      className="form-check-label ps-2 pe-3 text-d-bg-text text-sm mb-2 "
                      for="MealY"
                    >
                      Yes
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="is_meal_type"
                      onChange={handleChange}
                      id="MealN"
                      value={0}
                      checked={formData.is_meal_type == 0}
                    />
                    <label
                      className="form-check-label ps-2 pe-3 text-d-bg-text text-sm mb-2 "
                      for="MealN"
                    >
                      No
                    </label>
                  </div>
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Total meal quantity
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder=" "
                    name="item_qty"
                    onChange={handleChange}
                    value={formData.item_qty}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="submit"
              >
                Submit
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddSubForm;
